export enum EPositions {
	Left = 'left',
	Top = 'top',
	Right = 'right',
	Bottom = 'bottom'
}
export enum EInteractions {
	None = 'none',
	Pan = 'pan',
	Zoom = 'zoom',
	Both = 'both'
}
export enum EZoomRegions {
	Shift = 'shift',
	Alt = 'alt',
	Ctrl = 'ctrl'
}
